import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../services/configuration.service';

@Injectable({
    providedIn: 'root',
})
export class LocationHttpService {
    constructor(private configurations: ConfigurationService, private http: HttpClient) {}

    getAllLocations(): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/location/getAllLocations`);
    }

    getLocationById(locationId: any): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/location/getLocationById`, { params: { locationId: locationId } });
    }

    newLocation(location: any): Observable<any> {
        return this.http.post<any>(`${this.configurations.baseUrl}/api/location/newLocation`, location);
    }

    editLocation(location: any): Observable<any> {
        return this.http.put<any>(`${this.configurations.baseUrl}/api/location/editLocation`, location);
    }

    deleteLocation(locationId: any): Observable<any> {
        return this.http.delete<any>(`${this.configurations.baseUrl}/api/location/deleteLocation`, { params: { locationId: locationId } });
    }

    togglePublishLocation(locationId: any, value: any): Observable<any> {
        return this.http.put<any>(
            `${this.configurations.baseUrl}/api/location/togglePublishLocation`,
            {},
            {
                params: { locationId: locationId, value: value },
            }
        );
    }
}
